import { ChannelKind, OpenedChannelKind } from 'shared/entities/channels';
import { IRootStore } from 'shared/entities/store/rootStore';
import {
  AnyChannelCreationStores,
  JivoCreationStore,
  MAXChannelCreationStore,
  TelegramChannelCreationStore,
  ViberChannelCreationStore,
  VKCreationStore,
  WazzupCreationStore,
  WidgetChannelCreationStore
} from 'stores/channelCreationStores';

export const mapChannelKindToCreateStore: Record<
  OpenedChannelKind,
  (_rootStore: IRootStore) => AnyChannelCreationStores
> = {
  [ChannelKind.TELEGRAM]: (rootStore) =>
    new TelegramChannelCreationStore({ rootStore }),
  [ChannelKind.VK]: (rootStore) => new VKCreationStore(rootStore),
  [ChannelKind.VB]: (rootStore) => new ViberChannelCreationStore({ rootStore }),
  [ChannelKind.JIVO]: (rootStore) => new JivoCreationStore(rootStore),
  [ChannelKind.WZ]: (rootStore) => new WazzupCreationStore({ rootStore }),
  [ChannelKind.MAX]: (rootStore) => new MAXChannelCreationStore({ rootStore }),
  [ChannelKind.WIDGET]: (rootStore) =>
    new WidgetChannelCreationStore({ rootStore })
};
